import { HttpClient } from '@angular/common/http';
import { Action, Selector, StateContext, State, Store } from '@ngxs/store';
import { environment } from '../../../environments/environment';
import { FingerprintService } from '../../services/fingerprint.service';
import { GeolocationService } from '../../services/geolocation.service';
import {
  GenerateFingerprint,
  SaveFingerprint,
  SaveFingerprintInput
} from '../actions/fingerprint.action';

export interface Fingerprint {
  value: string;
}

@State<Fingerprint>({
  name: 'fingerprint',
  defaults: {
    value: ''
  }
})
export class FingerprintState {
  constructor(
    protected store: Store,
    protected fingerprintService: FingerprintService,
    protected http: HttpClient,
    protected geolocationService: GeolocationService
  ) {}

  @Selector()
  static FINGERPRINT(state: Fingerprint) {
    return state.value;
  }

  @Action(GenerateFingerprint)
  async GenerateFingerprint({ patchState }: StateContext<Fingerprint>) {
    await new Promise(async (resolve) => {
      const f = await this.fingerprintService.generateFingerprint();
      f.subscribe((fingerprint) => {
        patchState({ value: fingerprint });
        resolve(fingerprint);
      });
    });
  }

  @Action(SaveFingerprint)
  async SaveFingerprint(
    stateContext: StateContext<Fingerprint>,
    { saveFingerprintInput }: { saveFingerprintInput: SaveFingerprintInput }
  ) {
    const { getState } = stateContext;
    const { agentId, type } = saveFingerprintInput;
    const url =
      environment.apiCadastroSettings.url +
      environment.apiCadastroSettings.saveFingerprint;

    const { value } = getState();

    await this.http
      .post(url, {
        agentId,
        value,
        type
      })
      .toPromise();
  }
}
